import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import YesNoQuestion from '../../../ui/advisory-flow/components/shared-components/YesNoQuestion';
import QuestionGroupActions from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupActions';
import AdvisoryFlowMainContainer from '../../../ui/advisory-flow/components/app-shell/AdvisoryFlowMainContainer';
import QuestionGroupAssistantQuestion from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupAssistantQuestion';
import QuestionGroupBody from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupBody';
import useMobileBreakpoints from '../../../../../../common/src/hooks/useMobileBreakpoints';

interface Props {
  previousQuestionHandler: () => void;
  nextSubView: (arg0: string) => void;
}

const VinCheck: React.FC<React.PropsWithChildren<Props>> = ({
  previousQuestionHandler,
  nextSubView,
}) => {
  const { t } = useTranslation();
  const { isLaptop } = useMobileBreakpoints();

  return (
    <AdvisoryFlowMainContainer data-test-id="ProdFac_VinCheck">
      <QuestionGroupAssistantQuestion
        question={t('Do you know the VIN-number of the vehicle?')}
        description={t(
          'If you dont know the answer just leave empty and click next',
        )}
      />
      <QuestionGroupBody>
        {isLaptop && (
          <YesNoQuestion
            handleYes={() => nextSubView('vinSearch')}
            handleNo={() => nextSubView('vehicleSearch')}
          />
        )}
      </QuestionGroupBody>
      <QuestionGroupActions onBack={previousQuestionHandler} hideContinueButton>
        {!isLaptop && (
          <YesNoQuestion
            handleYes={() => nextSubView('vinSearch')}
            handleNo={() => nextSubView('vehicleSearch')}
          />
        )}
      </QuestionGroupActions>
    </AdvisoryFlowMainContainer>
  );
};

export default VinCheck;
